var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.name!='main')?_c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.breadCrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"pt-5",attrs:{"to":item.to,"disabled":item.disabled,"exact":""}},[_vm._v(" "+_vm._s(_vm.$t(item.text))+" ")])]}}],null,false,144484490)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }